import state from "./moduleTemplateMailState";
import mutations from "./moduleTemplateMailMutations";
import actions from "./moduleTemplateMailActions";
import getters from "./moduleTemplateMailGetters";

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}